import React, { createContext, useState, useEffect } from 'react';
import axios from 'axios';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const logout = () => {
        localStorage.clear(); // બધો જ ડેટા એકસાથે સાફ કરવા માટે
        setUser(null);
        window.location.href = '/login'; // આ લાઈન ઓટોમેટિક પેજ રિફ્રેશ કરીને લોગિન પર લઈ જશે
    };

    // 🔥 નવું ફંક્શન: ચાલુ સિસ્ટમમાં લેટેસ્ટ પાવર ખેંચવા માટે
    const refreshUser = async () => {
        const token = localStorage.getItem('token');
        if (token) {
            try {
                const res = await axios.get('/api/auth/me', { headers: { Authorization: `Bearer ${token}` } });
                localStorage.setItem('user', JSON.stringify(res.data.user));
                setUser(res.data.user);
            } catch (err) {
                if (err.response?.status === 401) logout();
            }
        }
    };

    useEffect(() => {
        const token = localStorage.getItem('token');
        const userData = localStorage.getItem('user');
        const loginDate = localStorage.getItem('loginDate');
        const today = new Date().toDateString();

        if (token && userData) {
            if (loginDate !== today) {
                logout();
            } else {
                // 🔥 Try-Catch ઉમેર્યું જેથી ડેટા કરપ્ટ હોય તો એપ ક્રેશ ના થાય
                try {
                    setUser(JSON.parse(userData));
                    refreshUser();
                } catch (error) {
                    logout();
                }
            }
        }
        setLoading(false);
    }, []);

    const login = (token, userData) => {
        localStorage.setItem('token', token);
        localStorage.setItem('user', JSON.stringify(userData));
        localStorage.setItem('loginDate', new Date().toDateString()); // 🔥 Aajni date save thashe
        setUser(userData);
    };

    return (
        <AuthContext.Provider value={{ user, login, logout, refreshUser, loading }}>
            {children}
        </AuthContext.Provider>
    );
};